package com.shadowings.gero.presentation.screen.characters

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.shadowings.gero.presentation.ui.AppTheme
import com.shadowings.gero.presentation.util.DevicePreviews
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.basco
import gero.composeapp.generated.resources.indiana
import org.jetbrains.compose.resources.DrawableResource

data class HatTypeOptionData(
    val drawable: DrawableResource,
    val contentDescription: String,
    val locked: Boolean = false,
    val lockCaption: String? = null,
)

@DevicePreviews
@Preview
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun HatTypeSectionPreview() {
    AppTheme {
        Surface {
            HatTypeSection(
                title = "Stile Cappello",
                options = listOf(
                    HatTypeOptionData(Res.drawable.indiana, "Esploratore"),
                    HatTypeOptionData(Res.drawable.basco, "Basco"),
                ),
                selectedIndex = 0,
                onSelect = {}
            )
        }
    }
}

@Composable
fun HatTypeSection(
    title: String,
    options: List<HatTypeOptionData>,
    selectedIndex: Int,
    onSelect: (Int) -> Unit,
    onLockedClick: (Int) -> Unit = {},
    modifier: Modifier = Modifier,
) {
    if (title.isNotBlank()) {
        Text(
            text = title,
            style = MaterialTheme.typography.titleMedium,
            modifier = Modifier
                .fillMaxWidth()
                .wrapContentWidth(Alignment.CenterHorizontally)
        )

        Spacer(Modifier.height(6.dp))
    }

    Row(
        modifier = modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(16.dp, Alignment.CenterHorizontally),
        verticalAlignment = Alignment.Top
    ) {
        options.forEachIndexed { idx, option ->
            HatTypeCard(
                drawable = option.drawable,
                contentDescription = option.contentDescription,
                selected = idx == selectedIndex,
                locked = option.locked,
                caption = option.lockCaption,
                onClick = { if (option.locked) onLockedClick(idx) else onSelect(idx) },
                tag = "hat_type_card_$idx"
            )
        }
    }
}
